import { useEffect } from "react";
import { useQuery } from "@tanstack/react-query";
import { apiFetch } from "../api";
import { applyTheme } from "../theme";
import type { Theme } from "../theme";
import { authKeys } from "../queryKeys";

export interface User {
  id: string;
  email: string;
  display_name: string;
  plan: string;
  theme?: string;
}

export const AUTH_ME_QUERY_KEY = authKeys.me;

export function useAuth() {
  const { data, isLoading, error } = useQuery({
    queryKey: authKeys.me,
    queryFn: () => apiFetch<{ user: User }>("/api/auth/me"),
    staleTime: 5 * 60 * 1000,
  });

  const user = data?.user ?? null;

  useEffect(() => {
    if (user?.theme) {
      applyTheme(user.theme as Theme);
    }
  }, [user?.theme]);

  return { user, isLoading, error };
}
